import { colorService } from '@logz-pkg/utils';
import { colorsDark } from '../../../../../components/themes';

export const graphDarkV2Theme = {
  gridLineColor: colorsDark.royalBlue[100],
  labelColor: colorsDark.royalBlue[900],
  lineColor: colorsDark.gray[800],
  crosshairColor: colorsDark.gray[900],
  barCrosshairColor: colorService.convertHexToRgba('#E6EAEC', 0.6),
  oppositeYAxisLineColor: colorsDark.gray[1000],
  oppositeYAxisLabelColor: '#09A2C3',
  markerOnHoverColor: colorsDark.gray[1000],
  eventActionMenuCardBorderColor: colorsDark.blue[400],
  eventActionMenuCardTextColor: colorsDark.gray[1000],
  eventActionMenuCardButtonTextColor: colorsDark.royalBlue[1000],
  eventActionMenuCardIconColor: colorsDark.royalBlue[1000],
};
